"use client";

import SiteFooter from "@/components/site/SiteFooter";
import SiteHeader from "@/components/site/SiteHeader";
import NextTopLoader from "nextjs-toploader";
import AuthProvider from "../context/AuthContext";
import ToasterContext from "../context/ToastContext";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <NextTopLoader
        color="#3269ff"
        crawlSpeed={300}
        showSpinner={false}
        shadow="none"
      />
      <AuthProvider>
        <ToasterContext />
        <a href="#main" className="skip">
          Skip to content
        </a>
        <SiteHeader />
        <div id="main" tabIndex={-1}>
          {children}
        </div>
        <SiteFooter />
      </AuthProvider>
    </>
  );
}
